import React from 'react';
import Helmet from 'react-helmet';

import favicon from 'img/favicon.png';

const BASE_TITLE = 'Reinvent Software';
const SITE_DESCRIPTION = 'We build modern, reliable software to help you work better.';


function absoluteAssetURL(relativePath) {  // HACK
    const path = relativePath.replace(/^\/+/, '');
    return `https://www.reinventsoftware.io/${path}`;
}


export default function SiteHead({title, description=SITE_DESCRIPTION, image, children}) {
    let siteTitle = BASE_TITLE;
    if (title) {
        siteTitle = `${title} - ${siteTitle}`;
    }
    return <Helmet>
        <title>{siteTitle}</title>
        <link rel="icon" href={favicon} />
        <meta name="description" content={description} />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={description} />
        {image && <meta property="og:image" content={absoluteAssetURL(image)} />}
        {children}
    </Helmet>;
}



// WEBPACK FOOTER //
// ./src/components/Head.js